// extracted by mini-css-extract-plugin
export default {"title":"FifthScreen_title__-1VN7","description":"FifthScreen_description__0GCHu"};